import React from 'react';
import { faCopyright } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PageFooter: React.FC = () => {
  return (
    <div className="page-footer card clearfix">
      <span className="footer-text" style={{ marginLeft: '5px' }}>InforByte Desenvolvimento de Software </span>
      <span className="footer-text">
        <FontAwesomeIcon icon={faCopyright}></FontAwesomeIcon>
        <span> All Rights Reserved</span>
      </span>
    </div>
  );
}

export default PageFooter;
